import { useState } from 'react'
import type { FollowUpTask } from '@/types/crm'
import { formatDate } from '@/shared/util/dates'

interface Props {
  task: FollowUpTask | null
  onComplete: (task: FollowUpTask) => Promise<void>
}

export function NextFollowUpCard({ task, onComplete }: Props) {
  const [saving, setSaving] = useState(false)

  const handleComplete = async () => {
    if (!task) return
    setSaving(true)
    try {
      await onComplete(task)
    } finally {
      setSaving(false)
    }
  }

  const done = Boolean(task?.doneAt)

  return (
    <section className="card card--surface">
      <div className="card-label">Next follow-up</div>
      {task ? (
        <>
          <div className="followup__text">{task.text}</div>
          <div className="followup__meta">
            {formatDate(task.dueDate)} · {task.assignee}
          </div>
          <button className="btn btn--primary" onClick={handleComplete} disabled={saving || done}>
            {done ? 'Done' : saving ? 'Saving…' : 'Mark as done'}
          </button>
        </>
      ) : (
        <div className="empty-note">No follow-up scheduled. Set a date when you decide the next move.</div>
      )}
    </section>
  )
}
